{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://schemas.fortemi.dev/knowledge-shard/1.2.0/full-v1/embedding.schema.json",
  "title": "Fortemi Knowledge Shard full-v1 candidate embedding record",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "id",
    "note_id",
    "embedding_set_id",
    "chunk_index",
    "text",
    "vector",
    "model",
    "created_at"
  ],
  "properties": {
    "id": {
      "$ref": "#/$defs/uuid"
    },
    "note_id": {
      "$ref": "#/$defs/nullableUuid"
    },
    "embedding_set_id": {
      "$ref": "#/$defs/nullableUuid"
    },
    "chunk_index": {
      "type": "integer"
    },
    "text": {
      "type": "string"
    },
    "vector": {
      "oneOf": [
        {
          "type": "array",
          "minItems": 768,
          "maxItems": 768,
          "items": {
            "type": "number"
          }
        },
        {
          "type": "null"
        }
      ]
    },
    "model": {
      "type": "string",
      "minLength": 1
    },
    "contract_fingerprint": {
      "oneOf": [
        {
          "type": "string",
          "pattern": "^[0-9a-f]{64}$"
        },
        {
          "type": "null"
        }
      ]
    },
    "created_at": {
      "oneOf": [
        {
          "$ref": "#/$defs/dateTime"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "$defs": {
    "uuid": {
      "type": "string",
      "format": "uuid"
    },
    "dateTime": {
      "type": "string",
      "format": "date-time"
    },
    "nullableUuid": {
      "oneOf": [
        {
          "$ref": "#/$defs/uuid"
        },
        {
          "type": "null"
        }
      ]
    }
  }
}
